<template>
    <li>
        <slot>
            {{ item }}
        </slot>
    </li>
</template>

<script>
export default {
    name: 'ListItem',
    props: {
        item: {
            type: [String, Number],
            default: null,
        },
    },
};
</script>
